const API_BASE_URL = process.env.BASE_URL

export const LIVEBLOCKS_ENDPOINTS = {
    AUTH: API_BASE_URL + "/api/liveblocks/auth/",
}
